import { Injectable } from '@angular/core';

export interface ReferralFormData {
  firstname: string;
  middlename: string;
  lastname: string;
  dob: string; // MM/DD/YYYY
  birthsex: string; // male|female|Prefer not to say
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  submitterFirstName: string;
  submitterLastName: string;
  submitterPhone: string;
  Submitteremail: string;
  Submitterfax: string;
  affiliatedCompany: string;
  reasonForReferral: string;
  stateOfCare: string;
  visitReason: string;
  smsConsent: boolean;
}

@Injectable({ providedIn: 'root' })
export class ReferralContextService {
  private data: Partial<ReferralFormData> = {};
  private dateReceived: string = '';
  private timeReceived: string = '';

  setFormData(next: Partial<ReferralFormData>) {
    this.data = { ...this.data, ...next };
  }

  getFormData(): Partial<ReferralFormData> {
    return { ...this.data };
  }

  setSubmissionDateTime(dateMMDDYYYY: string, timeHHMMSS: string) {
    this.dateReceived = dateMMDDYYYY;
    this.timeReceived = timeHHMMSS;
  }

  getSubmissionDate(): string { return this.dateReceived; }
  getSubmissionTime(): string { return this.timeReceived; }
}


